import {Richtext} from '@vw-marketing/us-components';
import React from 'react';
import {useFeatureAppConfig} from '../../hooks/use-feature-app-config';
import {useTranslations} from '../../hooks/use-translations';
import {DEFAULT_FILTERS_CONFIG} from '../../utils/app-constants';
import {totalResultsTextOverrides} from './helpers';
import {StyledPaginationInformationContainer} from './styles';

interface SearchPaginationDataDisplayProps {
  totalVehicles: number | Number;
  distance: string;
  pageSize: number;
  currentPage: number;
}
const SearchPaginationDataDisplay: React.FC<
  SearchPaginationDataDisplayProps
> = (props) => {
  let {totalVehicles = 0, pageSize, currentPage, distance} = props;
  const {headerResults} = useTranslations().resultsSection;
  const {distance: distanceConfig} = {
    ...DEFAULT_FILTERS_CONFIG,
    ...useFeatureAppConfig().filterConfig,
  };

  let totalResultsText = headerResults.resultsMarkdownLabel
    ?.replace('%%totalElements%%', totalVehicles?.toString() || '0')
    ?.replace(
      '%%miles%%',
      parseInt(distance) === distanceConfig.plusValue
        ? `${distanceConfig.maxDistance}+`
        : distance,
    );

  const currentVehicle = currentPage * pageSize;
  const lastPageVehicle = currentVehicle + pageSize;

  if (totalVehicles <= 0) {
    totalResultsText = totalResultsText?.replace('%%current%%', '0');
  } else {
    totalResultsText = totalResultsText?.replace(
      '%%current%%',
      `${currentVehicle + 1}-${
        lastPageVehicle > totalVehicles ? totalVehicles : lastPageVehicle
      }`,
    );
  }

  return (
    <StyledPaginationInformationContainer className="pagination-information_container">
      <Richtext
        markdown={totalResultsText}
        overrides={totalResultsTextOverrides}
      />
    </StyledPaginationInformationContainer>
  );
};

export default SearchPaginationDataDisplay;
